import React, { useEffect, useState } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import { BACKGROUND_COLOR } from "constants/Constant";



const Admin = (props) => {
const mainContent = React.useRef(null);
const location = useLocation();
const [isLoading, setIsloading] = useState(true);

  useEffect(() => {
    var sessionData = sessionStorage.getItem("type");
    if (sessionData) {
      if (sessionData !== "admin" && sessionData !== "sub-admin") {    
        window.location.assign("/auth/login");
      } else {
        setIsloading(false)
        if (location.pathname === "/") {
          window.location.assign("/admin/index");
        }
      }
    }
     else {
      window.location.assign("/auth/login");
   }
  }, [location]);

  useEffect(() => {
    if(!isLoading) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      mainContent.current.scrollTop = 0;
    }
  }, [isLoading])

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        const parentRoute = (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
  
        // Render child routes
        const childRoutes = prop.children && prop.children.map((child, index) => {
          
          if (child.layout === "/admin") {
            return (
              <Route path={child.path} element={child.component} key={index} />
            );
          }
          return null;
        });
      
  
        // Return both parent and child routes
        return (
          <React.Fragment key={key}>
            {parentRoute}
            {childRoutes}
      
          </React.Fragment>
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
   <>
  {!isLoading && (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/goodybuddy_long.png"),
          imgAlt: "...",
        }}
      />

      <div
        className="main-content pt-5"
        ref={mainContent}
        style={{ backgroundColor: BACKGROUND_COLOR }}
      >
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />

        <div className=" d-flex flex-column"style={{ minHeight: "calc(100vh - 48px)" }}>
          <div className="flex-grow-1">
            <Routes>{getRoutes(routes)}</Routes>
          </div>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </div>
    </>
  )}
</>
  );
};

export default Admin;
